import React, { useState } from 'react';
import { Auth } from 'aws-amplify';

/**
 * Minimal Cognito username/password login. Handles the NEW_PASSWORD_REQUIRED
 * challenge that admin-created users hit on first sign-in.
 */
export default function Login({ onSignedIn }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [challengeUser, setChallengeUser] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const u = await Auth.signIn(username.trim(), password);
      if (u.challengeName === 'NEW_PASSWORD_REQUIRED') {
        setChallengeUser(u);
      } else {
        onSignedIn();
      }
    } catch (err) {
      setError(err.message || 'Sign in failed');
    } finally {
      setBusy(false);
    }
  };

  const completeNewPassword = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await Auth.completeNewPassword(challengeUser, newPassword);
      onSignedIn();
    } catch (err) {
      setError(err.message || 'Could not set new password');
    } finally {
      setBusy(false);
    }
  };

  if (challengeUser) {
    return (
      <div className="centered">
        <form className="card login" onSubmit={completeNewPassword}>
          <h2>Set a new password</h2>
          <input
            type="password"
            placeholder="New password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            autoFocus
          />
          {error && <div className="error">{error}</div>}
          <button type="submit" disabled={busy}>
            {busy ? 'Saving…' : 'Save password'}
          </button>
        </form>
      </div>
    );
  }

  return (
    <div className="centered">
      <form className="card login" onSubmit={submit}>
        <h2>SMAX Scenario Tests</h2>
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoFocus
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        {error && <div className="error">{error}</div>}
        <button type="submit" disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
